/* eslint-disable */

import request from '@/utils/request'

export function getListSubTransactionTypeApi(query) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction-type',
    method: 'get',
    params: query
  })
}

export function addSubTransactionTypeApi(query) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction-type',
    method: 'post',
     data: query
  })
}

export function updateSubTransactionTypeApi(query) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction-type',
    method: 'put',
     data: query
  })
}

export function deleteSubTransactionTypeApi(query) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction-type',
    method: 'delete',
    data: query
  })
}
